import { CommandStatus } from '../../../shared/ui/CommandStatus'
import type { KeyedCommand } from '../model/viewModels'

/** Итоги команд окна: каждая — своё состояние; «неизвестно» не скрывается и не повторяется само. */
export function Commands({
  commands,
  onResend,
  onDismiss,
}: {
  commands: readonly KeyedCommand[]
  onResend: (key: string) => void
  onDismiss: (key: string) => void
}) {
  if (commands.length === 0) return null
  return (
    <div className="onec-screen" aria-label="Итоги команд">
      {commands.map((command) => (
        <CommandStatus
          key={command.key}
          command={command}
          onResend={() => onResend(command.key)}
          onDismiss={() => onDismiss(command.key)}
        />
      ))}
    </div>
  )
}
